<wl-structured-data [structuredData]="structuredData()"></wl-structured-data>
<wl-faq
  class="container d-block"
  [feedbackSettings]="feedbackSettings()"
  [faq]="faq()"
/>
